import { HttpContext, HttpContextToken } from '@angular/common/http';

export const showToast = new HttpContextToken<boolean>(() => true);

export function hideToast() {
    return new HttpContext().set(showToast, false);
}
